import { createRoute, redirect, type AnyRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { PartnersPage } from "./pages/PartnersPage";

/** Search params on /partners. Drawer state is the only consumer today. */
export interface PartnersSearch {
  partner?: string;
  expanded?: boolean;
}

function validatePartnersSearch(raw: Record<string, unknown>): PartnersSearch {
  const out: PartnersSearch = {};
  if (typeof raw.partner === "string" && raw.partner.length > 0) {
    out.partner = raw.partner;
  }
  if (raw.expanded === true || raw.expanded === "1" || raw.expanded === "true") {
    out.expanded = true;
  }
  return out;
}

export const partnersModule: FeatureModule = {
  key: "partners",
  nav: {
    label: "Partners",
    icon: Users,
    to: "/partners",
    requires: "partners.read",
    order: 40,
    group: "Operations",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/partners",
      component: guarded("partners.read", PartnersPage),
      validateSearch: validatePartnersSearch,
    }),
    // Legacy permalink — drawer now owns the expanded view. Old bookmarks
    // resolve via redirect into the drawer-expanded state.
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/partners/$accountId",
      beforeLoad: ({ params }) => {
        throw redirect({
          to: "/partners",
          search: { partner: params.accountId, expanded: true },
        });
      },
      component: () => null,
    }),
  ] as unknown as AnyRoute[],
};
